<template>
  <FormCard>
    <template #header>
      <div class="card-header">
        <div>
          <div class="card-header__title">비밀번호 일괄 변경</div>
          <p class="card-header__desc">
            선택한 학교의 <strong>전체 계정</strong> 비밀번호가 한 번에 변경됩니다. 비가역 작업이므로 신중히 진행하세요.
          </p>
        </div>
      </div>
    </template>

    <div class="form-grid">
      <div class="form-field">
        <label class="form-field__label">
          학교 선택 (USER) <span class="form-field__required">(필수)</span>
        </label>
        <div class="form-field__control">
          <v-autocomplete
            v-model="searchschool"
            :items="searchlist"
            no-data-text="결과를 찾을 수 없습니다."
            placeholder="학교를 검색해주세요."
            auto-select-first
            append-inner-icon="mdi-magnify"
            item-props
            density="compact"
            menu-icon=""
            variant="outlined"
            color="primary"
            hide-details
            spellcheck="false"
            @keyup.enter="schoolsearch()"
            @change="onChangeTest()"
          />
        </div>
        <p class="form-field__helper">학교명 또는 코드(영문/숫자)로 검색</p>
      </div>

      <div class="form-field">
        <label class="form-field__label">
          새 비밀번호 <span class="form-field__required">(필수)</span>
        </label>
        <div class="form-field__control">
          <v-text-field
            v-model="password"
            placeholder="6자리 이상, 영어 소문자 + 숫자 조합"
            density="compact"
            variant="outlined"
            color="primary"
            hide-details
            spellcheck="false"
          />
        </div>
        <p class="form-field__helper">규칙: 영어 소문자 + 숫자 포함, 6자 이상</p>
      </div>

      <div class="form-action">
        <button class="btn-primary" @click="onClickSet">비밀번호 설정</button>
      </div>
    </div>
  </FormCard>
</template>

<script setup>
import { ref, onBeforeMount, reactive } from "vue";
import { useStore } from "vuex";
import FormCard from "@/components/ui/FormCard.vue";

const store = useStore();

const searchdata = ref("");
const schoolCode = ref("");
const searchschool = ref(null);
const searchlist = ref([]);

const password = ref("");

const data = reactive({ schoolCode: "", password: "" });

const onClickSet = async () => {
  data.password = password.value.trim();
  const check = /^(?=.*[A-Za-z])(?=.*[0-9])[a-z0-9]{6,}$/.test(data.password);

  if (data.schoolCode !== "" && data.password !== "" && check === true) {
    if (confirm("비밀번호를 설정하시겠습니까?")) {
      const res = await store.dispatch("POST_PASSWORD_CUSTOM", data);
      if (res.result === true) {
        alert(
          `${searchschool.value} 전체 계정 비밀번호가 변경 되었습니다.\n\n변경 비밀번호: ${data.password}`
        );
        location.reload(true);
      } else if (res === 100) {
        alert("통신에 오류가 발생했습니다.");
        location.reload(true);
      } else {
        alert("오류가 발생했습니다.");
        location.reload(true);
      }
    }
  } else if (check === false) {
    alert("비밀번호가 조건에 충족하지 않습니다.");
  } else {
    alert("형식을 모두 작성해주세요.");
  }
};

const schoolsearch = async () => {
  if (searchdata.value[searchschool.value]) {
    let regex = /^[a-zA-Z0-9]*$/;

    if (regex.test(searchschool.value)) {
      schoolCode.value = searchschool.value;
      searchschool.value = searchdata.value[searchschool.value];
      data.schoolCode = schoolCode.value;
    } else {
      schoolCode.value = Object.keys(searchdata.value).find(
        (key) => searchdata.value[key] === searchschool.value
      );
      data.schoolCode = schoolCode.value;
    }
  } else {
    searchschool.value = "";
    schoolCode.value = "";
    alert("학교 정보가 존재하지 않습니다.");
  }
};

const onChangeTest = (newValue) => {
  // 기존 동작 보존
  console.log("change : ", newValue);
};

onBeforeMount(async () => {
  try {
    const res = await store.dispatch("GET_SEARCH_LIST");
    searchdata.value = res;
    searchlist.value = Object.getOwnPropertyNames(res);
  } catch (err) {
    console.log(err);
  }
});
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
}

.card-header__title {
  font-size: var(--font-h3-size);
  line-height: var(--font-h3-line);
  font-weight: var(--font-h3-weight);
  color: var(--text-primary);
}

.card-header__desc {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
  font-weight: 400;
}

.form-grid {
  display: grid;
  grid-template-columns: minmax(240px, 320px) minmax(240px, 320px) auto;
  gap: var(--space-5);
  align-items: end;
}

.form-field__label {
  display: block;
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  line-height: var(--font-body-strong-line);
  color: var(--text-primary);
  margin-bottom: var(--space-2);
}

.form-field__required {
  margin-left: var(--space-1);
  font-size: var(--font-caption-size);
  font-weight: 400;
  color: #B42318;
}

.form-field__helper {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.form-action {
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  height: 36px;
  padding: 0 var(--space-4);
  background: var(--color-primary-600);
  color: var(--text-on-primary);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-body-size);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.btn-primary:hover {
  background: var(--color-primary-700);
}

@media (max-width: 960px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-action {
    justify-content: flex-start;
  }
}
</style>
